module.exports = __webpack_public_path__ + "static/media/bouquet-md.681f4d40.svg";